/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "DeviceAttributes": {
                "nested": {
                  "DeviceType": {
                    "values": {
                      "DEVICE_TYPE_INVALID_TYPE": 0,
                      "TERMINAL": 1,
                      "REGISTER": 2,
                      "IOS": 3,
                      "ANDROID": 4,
                      "CASH_DRAWER": 5,
                      "PRINTER": 6,
                      "READER": 7,
                      "SCALE": 8,
                      "BARCODE_SCANNER": 9,
                      "STAND": 10,
                      "INTERNAL_PRINTER": 11,
                      "SCANNER_SCALE": 12,
                      "INTERNAL_SCANNER": 13,
                      "HANDHELD": 14,
                      "THIRD_PARTY_TERMINAL": 15,
                      "KIOSK": 16
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceAttributes?.nested?.DeviceType) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE DeviceAttributes @ squareup/devices/external/device.proto at 110:1
 */
export const DeviceAttributes = {};
/**
 * --
 * @desc An enum identifier of the device type.
 * --
 *
 * SOURCE DeviceType @ squareup/devices/external/device.proto at 116:3
 */
DeviceAttributes.DeviceType = $root.lookupEnum('squareup.connect.v2.DeviceAttributes.DeviceType').values;
